import React from 'react';
import connectToI18n from 'modules/i18n/connectToI18n';
import PropTypes from 'prop-types';

export class ErrorPage extends React.Component {
    static propTypes = {
        trans: PropTypes.func.isRequired,
        errorType: PropTypes.string.isRequired,
    };

    renderMaintenance = () => {
        const trans = this.props.trans;

        return (
            <div className="maintenance">
                <div className="row">
                    <div className="col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 u-center">
                        <img
                            src="/assets/images/maintenance.svg"
                            className="maintenance-img"
                            alt=""
                        />
                        <div className="box maintenance-box">
                            <h2 className="maintenance-title">{trans('maintenance.title')}</h2>
                            <p className="maintenance-text">
                                {trans('maintenance.reason.maintenance')}{' '}
                                {trans('maintenance.until.inAFewMinutes')}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    renderAssemblyNotFound = (errorCode, title, content) => {
        const trans = this.props.trans;

        return (
            <div className="main">
                <div className="error-page" data-error={errorCode}>
                    <h1>{trans(title)}</h1>
                    <p>{trans(content)}</p>
                    <img src="/assets/images/error-illustration.png" alt="" />
                    <p className="back-link">
                        <a className="btn btn-large" href="/">
                            {trans('global.back')}
                        </a>
                    </p>
                </div>
            </div>
        );
    };

    renderOther = (errorCode, title, content) => {
        const trans = this.props.trans;

        return (
            <div className="main">
                <div className="error-page" data-error={errorCode}>
                    <h1>{trans(title)}</h1>
                    <p>{trans(content)}</p>
                    <img src="/assets/images/error-illustration.png" alt="" />
                    <p className="back-link">
                        <a className="btn btn-large" href="#" data-behavior="back">
                            {trans('global.back')}
                        </a>
                    </p>
                </div>
            </div>
        );
    };

    renderRedirectionMessage = () => {
        const greetings = [
            {
                locale: 'fr-FR',
                flag: 'flag_fr-FR.svg',
                greeting: 'Bonjour',
                message: 'Pour cette demande, veuillez visiter',
                url: 'https://laruchequiditoui.fr/fr',
            },
            {
                locale: 'nl-BE',
                flag: 'flag_nl-BE.svg',
                greeting: 'Hallo',
                message: 'Voor dit verzoek, bezoek',
                url: 'https://boerenenburen.be/nl-BE',
            },
            {
                locale: 'fr-BE',
                flag: 'flag_fr-BE.svg',
                greeting: 'Bonjour',
                message: 'Pour cette demande, veuillez visiter',
                url: 'https://laruchequiditoui.be/fr-BE',
            },
            {
                locale: 'fr-CH',
                flag: 'flag_fr-CH.svg',
                greeting: 'Bonjour',
                message: 'Pour cette demande, veuillez visiter',
                url: 'https://ruchequiditoui.ch/fr-CH',
            },
            {
                locale: 'de-CH',
                flag: 'flag_de-CH.svg',
                greeting: 'Hallo',
                message: 'Für diese Anfrage besuchen Sie bitte',
                url: 'https://marktschwaermer.ch/de-CH',
            },
            {
                locale: 'de-DE',
                flag: 'flag_de-DE.svg',
                greeting: 'Hallo',
                message: 'Für diese Anfrage besuchen Sie bitte',
                url: 'https://marktschwaermer.de/de',
            },
            {
                locale: 'es-ES',
                flag: 'flag_es-ES.svg',
                greeting: 'Hola',
                message: 'Para esta solicitud, visite',
                url: 'https://lacolmenaquedicesi.es/es',
            },
            {
                locale: 'ca-ES',
                flag: 'flag_ca-ES.svg',
                greeting: 'Hola',
                message: 'Per a aquesta sol·licitud, visiteu',
                url: 'https://lacolmenaquedicesi.es/ca',
            },
            {
                locale: 'it-IT',
                flag: 'flag_it-IT.svg',
                greeting: 'Ciao',
                message: 'Per questa richiesta, visitare',
                url: 'https://alvearechedicesi.it/it',
            },
            {
                locale: 'nl-NL',
                flag: 'flag_nl-NL.svg',
                greeting: 'Hallo',
                message: 'Voor dit verzoek, bezoek',
                url: 'https://boerenenburen.nl/nl',
            },
            {
                locale: 'en-GB',
                flag: 'flag_en-GB.svg',
                greeting: 'Hello',
                message: 'For this request, please visit',
                url: 'https://thefoodassembly.com/',
            },
        ];

        const uniqueGreetings = [...new Set(greetings.map(item => item.greeting))];

        return (
            <div className="maintenance">
                <div className="row">
                    <div className="col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 u-center">
                        <img
                            src="/assets/images/maintenance.svg"
                            className="maintenance-img"
                            alt=""
                        />
                        <div className="box maintenance-box">
                            <h2 className="maintenance-title">
                                {uniqueGreetings.map((greeting, index) => (
                                    <span key={greeting}>
                                        {greeting}
                                        {index < uniqueGreetings.length - 1 ? ', ' : ''}
                                    </span>
                                ))}
                            </h2>
                            <div className="maintenance-text">
                                {greetings.map(item => (
                                    <p
                                        key={item.locale}
                                        style={{
                                            marginBottom: '8px',
                                            display: 'flex',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <img
                                            src={`/assets/images/corpo/flags/${item.flag}`}
                                            alt={`${item.locale} flag`}
                                            style={{
                                                width: '20px',
                                                height: '15px',
                                                marginRight: '8px',
                                            }}
                                        />
                                        {item.message}{' '}
                                        <a
                                            href={item.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                color: '#007cba',
                                                textDecoration: 'underline',
                                            }}
                                        >
                                            {item.url.replace('https://', '')}
                                        </a>
                                    </p>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const errorType = this.props.errorType;

        switch (errorType) {
            case 'redirection':
                return this.renderRedirectionMessage();
            case 'maintenance':
                return this.renderMaintenance();
            case 'assemblyNotFound':
                return this.renderAssemblyNotFound(
                    404,
                    'errors.notFound.title',
                    'errors.notFound.content'
                );
            case 'notFound':
                return this.renderOther(404, 'errors.notFound.title', 'errors.notFound.content');
            default:
                return this.renderOther(500, 'errors.internal.title', 'errors.internal.content');
        }
    }
}

export default connectToI18n(ErrorPage);
